import React, { useRef, useEffect, useState } from 'react'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'

export default function App() {
    const mountRef = useRef(null)
    const [action, setAction] = useState(null)
    const [playing, setPlaying] = useState(false) // start paused

    useEffect(() => {
        const container = mountRef.current
        if (!container) return

        // === SCÈNE, CAMÉRA, RENDERER ===
        const scene = new THREE.Scene()

        // === ENVIRONMENT MAP VIA JPEG ===
        const textureLoader = new THREE.TextureLoader()
        const envTexture = textureLoader.load(
            process.env.PUBLIC_URL + '/env/bg.jpeg', // place your JPEG in public/env/
            () => {},
            undefined,
            (err) => console.error('Error loading environment map:', err)
        )
        envTexture.mapping = THREE.EquirectangularReflectionMapping
        scene.environment = envTexture
        scene.background = envTexture

        const camera = new THREE.PerspectiveCamera(
            60,
            container.clientWidth / container.clientHeight,
            0.1,
            1000
        )
        camera.position.set(0, 1.5, 3)

        const renderer = new THREE.WebGLRenderer({ antialias: true })
        renderer.setSize(container.clientWidth, container.clientHeight)
        renderer.setPixelRatio(window.devicePixelRatio)
        container.appendChild(renderer.domElement)

        // === LUMIÈRES ===
        const ambient = new THREE.AmbientLight(0xffffff, 0.5)
        scene.add(ambient)
        const dirLight = new THREE.DirectionalLight(0xffffff, 0.5)
        dirLight.position.set(5, 10, 7.5)
        scene.add(dirLight)

        // === CONTROLES ORBIT ===
        const controls = new OrbitControls(camera, renderer.domElement)
        controls.enableDamping = true

        // === DRACO DECODER VIA CDN ===
        const dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/')
        dracoLoader.setDecoderConfig({ type: 'js' })

        // === GLTF LOADER ===
        const loader = new GLTFLoader()
        loader.setDRACOLoader(dracoLoader)

        const clock = new THREE.Clock()
        let mixer

        loader.load(
            process.env.PUBLIC_URL + '/models/window.glb',
            (gltf) => {
                scene.add(gltf.scene)
                mixer = new THREE.AnimationMixer(gltf.scene)
                const clip = gltf.animations[0]
                const actionInstance = mixer.clipAction(clip)
                actionInstance.setLoop(THREE.LoopOnce, 1)
                actionInstance.clampWhenFinished = true
                actionInstance.paused = true
                actionInstance.play()
                setAction(actionInstance)
            },
            undefined,
            (err) => console.error('Error loading model:', err)
        )

        // === BOUCLE ANIM ===
        function animate() {
            requestAnimationFrame(animate)
            const delta = clock.getDelta()
            if (mixer) mixer.update(delta)
            controls.update()
            renderer.render(scene, camera)
        }
        animate()

        // === HANDLE RESIZE ===
        function handleResize() {
            const w = container.clientWidth
            const h = container.clientHeight
            renderer.setSize(w, h)
            camera.aspect = w / h
            camera.updateProjectionMatrix()
        }
        window.addEventListener('resize', handleResize)

        // === CLEANUP ===
        return () => {
            window.removeEventListener('resize', handleResize)
            if (container.contains(renderer.domElement)) container.removeChild(renderer.domElement)
            dracoLoader.dispose()
            renderer.dispose()
        }
    }, [])

    // === Bouton Play/Pause ===
    const handleToggle = () => {
        if (!action) return
        if (!playing) {
            action.reset()
            action.paused = false
            setPlaying(true)
        } else {
            action.paused = true
            setPlaying(false)
        }
    }

    return (
        <div style={{ width: '100vw', height: '100vh', position: 'relative' }}>
            <div ref={mountRef} style={{ width: '100%', height: '100%' }} />
            <button
                onClick={handleToggle}
                style={{
                    position: 'absolute',
                    bottom: 20,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    padding: '0.5em 1em',
                    background: 'rgba(0, 0, 0, 0.2)',
                    backdropFilter: 'blur(5px)',
                    color: '#fff',
                    height: '100px',
                    width: '100px',
                    borderRadius: '50%',
                    border: '1px solid #ccc',
                    cursor: 'pointer',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="m256-236-20-20 224-224-224-224 20-20 224 224 224-224 20 20-224 224 224 224-20 20-224-224-224 224Z"/></svg>
            </button>
        </div>
    )
}
